<div id="app" class="app" *ngIf="authService.isUserAuthenticated$ | async ">
  <cm-header class="app__header"></cm-header>
  <cm-drawer class="app__drawer">
    <div class="app__main" [ngClass]="{ ' shrinked': navigationService.isShrinked }">
      <div class="app__navigation" [ngClass]="{ ' isMobile': isMobile }">
        <cm-navigation></cm-navigation>
      </div>
      <div class="app__content">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="app__footer"></div>
  </cm-drawer>
  <div class="app__footer"></div>
  <cm-toast-message></cm-toast-message>
</div>
